__webpack_require__.p = "https://RadarBob-dev.shipbob.dev/";